import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialPermissionsState = {
  status: STATUS.IDLE,
  error: null,
  permissionIds: [],
  permissionsById: {},
};

export default (state = initialPermissionsState, action) => {
  switch (action?.type) {
    case types.LOAD_PERMISSIONS:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_PERMISSIONS): {
      const permissionIds = [];
      const permissionsById = {};
      action.payload.results.forEach((permission) => {
        permissionIds.push(permission?.id);
        permissionsById[permission?.id] = permission;
      });
      return {
        ...state,
        permissionIds,
        permissionsById,
        status: STATUS.LOADED,
      };
    }
    default:
      return state;
  }
};
